import { api } from "@/lib/api";

// Single canonical accessor for the invoice document. The backend WeasyPrint
// renderer (`build_invoice_pdf`) is the ONE source of truth — Preview, Print,
// Download and the "Open in new tab" page all render these exact same bytes,
// so they are guaranteed to look identical.
export async function fetchInvoicePdfBlob(invoiceId, variant = "digital") {
  const resp = await api.get(`/invoices/${invoiceId}/pdf?variant=${variant}`, {
    responseType: "blob",
  });
  return resp.data;
}

export function invoicePdfFilename(invoiceNumber, invoiceId) {
  const base = invoiceNumber || invoiceId || "invoice";
  return `invoice-${base}.pdf`.replace(/\//g, "-").replace(/\s+/g, "-");
}
